
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';
import { UnreadMessagesProvider } from './contexts/UnreadMessagesContext.tsx';
import { CapacitorUtils } from './utils/capacitor';

// Initialize Capacitor when app loads
CapacitorUtils.initializeApp().catch(console.error);

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <UnreadMessagesProvider>
      <App />
    </UnreadMessagesProvider>
  </React.StrictMode>
);

// Register Service Worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js?v=2')
      .then((registration) => {
        console.log('✅ Service Worker registered successfully:', registration);
        // Force update check
        registration.update();
      })
      .catch((error) => {
        console.log('❌ Service Worker registration failed:', error);
      });
  });
}
